export enum LengthValidation {
  MAXIMUM = 15,
  MINIMUM = 5,
  GOOD = 8,
}
